import React from 'react';
import Icon from '../../../components/AppIcon';

const OrderStatusBadge = ({ status, size = 'default' }) => {
  const getStatusConfig = (status) => {
    switch (status?.toLowerCase()) {
      case 'completed':
        return {
          label: 'Completed',
          icon: 'CheckCircle',
          className: 'bg-success/10 text-success border-success/20'
        };
      case 'in-progress':
        return {
          label: 'In Progress',
          icon: 'Clock',
          className: 'bg-primary/10 text-primary border-primary/20'
        };
      case 'pending':
        return {
          label: 'Pending',
          icon: 'AlertCircle',
          className: 'bg-warning/10 text-warning border-warning/20'
        };
      case 'cancelled':
        return {
          label: 'Cancelled',
          icon: 'XCircle',
          className: 'bg-error/10 text-error border-error/20'
        };
      case 'shipped':
        return {
          label: 'Shipped',
          icon: 'Truck',
          className: 'bg-accent/10 text-accent border-accent/20'
        };
      default:
        return {
          label: 'Unknown',
          icon: 'HelpCircle',
          className: 'bg-muted text-muted-foreground border-border'
        };
    }
  };

  const config = getStatusConfig(status);
  const sizeClasses = size === 'sm' ? 'px-2 py-1 text-xs' : 'px-3 py-1.5 text-sm';

  return (
    <span className={`inline-flex items-center space-x-1.5 ${sizeClasses} font-medium rounded-full border ${config?.className}`}>
      <Icon name={config?.icon} size={size === 'sm' ? 12 : 14} />
      <span>{config?.label}</span>
    </span>
  );
};

export default OrderStatusBadge;